import { inherits as _inherits, classCallCheck as _classCallCheck, possibleConstructorReturn as _possibleConstructorReturn, getPrototypeOf as _getPrototypeOf, defineProperty as _defineProperty, assertThisInitialized as _assertThisInitialized, createClass as _createClass, objectWithoutProperties as _objectWithoutProperties, extends as _extends, objectSpread as _objectSpread } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { withContext, marginBottomLevels, eventBus, gridStyles, getMarginBottomClass, IconChevronDown } from '@piggybank/core';
import { Consumer } from '../Field/context.js';
import pick from 'lodash/fp/pick';
import omit from 'lodash/fp/omit';
import styles from './select.css.js';
var propsTypes = {
  fullWidth: PropTypes.bool,

  /** docgen-from-context:<Field/> */
  invalid: PropTypes.bool,

  /**
   * 0, 1, 2, 3, 4, 5, 6, 7
   */
  marginBottom: PropTypes.oneOf(marginBottomLevels),

  /** docgen-from-context:<Field/> */
  name: PropTypes.string.isRequired,

  /**
   * docgen-from-context:<Field/>
   * ---
   * proxied to eventBus
   */
  onChange: PropTypes.func.isRequired,

  /** docgen-from-context:<Field/> */
  onBlur: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired
  })).isRequired,
  placeholder: PropTypes.string,

  /** docgen-from-context:<Field/> */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** docgen-from-context:<Field/> */
  required: PropTypes.bool,

  /** docgen-from-context:<Field/> */
  describers: PropTypes.string
};
var defaultProps = {
  marginBottom: 0,
  placeholder: 'Please select'
};

var renderPlaceholder = function renderPlaceholder(value, placeholderText) {
  // This relies on no entry in the options having an empty string value
  // and intial value being an empty string. In the long term we may want to define a
  // unique value that indicates nothing has been selected.
  if (!value) {
    return React.createElement("option", {
      value: ""
    }, placeholderText);
  }
};

var renderOption = function renderOption(option) {
  return React.createElement("option", {
    key: option.value,
    value: option.value
  }, option.label);
};
/** docgen-ignore */


var SelectInner = /*#__PURE__*/function (_React$Component) {
  _inherits(SelectInner, _React$Component);

  function SelectInner() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, SelectInner);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SelectInner)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "getLabelFromValue", function (value) {
      var entry = _this.props.options.find(function (entry) {
        return entry.value === value;
      });

      return entry && entry.label;
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (event) {
      _this.props.onChange({
        value: event.target.value,
        event: event
      });

      eventBus.dispatch({
        type: 'onChange',
        component: 'Select',
        value: event.target.value,
        name: _this.props.name
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyUp", function (event) {
      var eTargetValue = event.target.value;

      if (eTargetValue !== _this.props.value && _this.props.options.some(function (entry) {
        return entry.value === eTargetValue;
      })) {
        _this.props.onChange({
          value: eTargetValue,
          event: event
        });
      }
    });

    return _this;
  }

  _createClass(SelectInner, [{
    key: "render",
    value: function render() {
      var _cn, _cn3;

      var _omit = omit(['onChange'], this.props),
          fullWidth = _omit.fullWidth,
          invalid = _omit.invalid,
          marginBottom = _omit.marginBottom,
          name = _omit.name,
          options = _omit.options,
          placeholder = _omit.placeholder,
          value = _omit.value,
          required = _omit.required,
          describers = _omit.describers,
          forwardedRef = _omit.forwardedRef,
          rest = _objectWithoutProperties(_omit, ["fullWidth", "invalid", "marginBottom", "name", "options", "placeholder", "value", "required", "describers", "forwardedRef"]);

      var selectedLabel = this.getLabelFromValue(value) || placeholder;
      return React.createElement("div", {
        className: cn(styles['Container'], (_cn = {}, _defineProperty(_cn, styles['Container--fullWidth'], fullWidth), _defineProperty(_cn, gridStyles['size-12'], !fullWidth), _defineProperty(_cn, gridStyles['sizeMedium-7'], !fullWidth), _defineProperty(_cn, gridStyles['sizeLarge-4'], !fullWidth), _cn), getMarginBottomClass(marginBottom))
      }, React.createElement("select", _extends({
        "aria-invalid": invalid,
        "aria-describedby": describers,
        className: cn(styles['Select'], _defineProperty({}, styles['Select--invalid'], invalid)),
        name: name,
        id: "".concat(name, "-field"),
        onChange: this.handleChange,
        onBlur: this.handleChange,
        onKeyUp: this.handleKeyUp,
        required: required,
        value: value,
        ref: forwardedRef
      }, rest), renderPlaceholder(value, placeholder), options.map(renderOption)), React.createElement("div", {
        "aria-hidden": "true",
        className: cn(styles['Value'], (_cn3 = {}, _defineProperty(_cn3, styles['Value--invalid'], invalid), _defineProperty(_cn3, styles.Placeholder, selectedLabel === placeholder), _cn3)),
        role: "presentation"
      }, selectedLabel), React.createElement("div", {
        className: styles.Icon
      }, React.createElement(IconChevronDown, {
        marginBottom: 0
      })));
    }
  }]);

  return SelectInner;
}(React.Component);

_defineProperty(SelectInner, "defaultProps", _objectSpread({}, defaultProps, {
  value: '',
  required: true
}));

SelectInner.propTypes = process.env.NODE_ENV !== "production" ? _objectSpread({}, propsTypes) : {};
var Select = React.forwardRef(function (props, ref) {
  return React.createElement(SelectInner, _extends({}, props, {
    forwardedRef: ref
  }));
});
Select.displayName = 'Select';
Select.propTypes = _objectSpread({}, propsTypes);
Select.defaultProps = defaultProps;
var Select$1 = withContext(Consumer, pick(['name', 'value', 'onChange', 'onBlur', 'invalid', 'required', 'describers']))(Select);
export default Select$1;
export { Select, SelectInner };